import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsModel } from '../../../shared/Model/setting.model';
import { SharedApiService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private endpoint2 = `Setting/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAllSettings(): Observable<{ value: SettingsModel[] }> {
    return this.sharedApiService.getAll(this.endpoint2);
  }
}
